<owl-carousel-o [options]="customOptions" *ngIf="arrayTestimonials" id="recommend">
    <ng-container *ngFor="let testimonial of arrayTestimonials">
        <ng-template carouselSlide>
            <app-card-testimonials [testimonial]="testimonial"></app-card-testimonials>
        </ng-template>
    </ng-container>
</owl-carousel-o>
